var fontSize = {
	"0": 0,
	"1": 0.09,
	"2": 0.18,
	"3": 0.27,
	"4": 0.36,
	"5": 0.44,
	"6": 0.53,
	"7": 0.61,
	"8": 0.69,
	"9": 0.77,
	"10": 0.85,
	"11": 0.92,
	"12": 1,
	"13": 1.08,
	"14": 1.15,
	"15": 1.23,
	"16": 1.3,
	"17": 1.37,
	"18": 1.45,
	"19": 1.52,
	"20": 1.59,
	"21": 1.66,
	"22": 1.73,
	"23": 1.81,
	"24": 1.88,
	"25": 1.96,
	"26": 2.04,
	"27": 2.12,
	"28": 2.2,
	"29": 2.28,
	"30": 2.35,
	"31": 2.43,
	"32": 2.51,
	"33": 2.58,
	"34": 2.66,
	"35": 2.73,
	"36": 2.81,
	"37": 2.89,
	"38": 2.96,
	"39": 3.04,
	"40": 3.12
};
var fontWeight = {
	"100": 0.97,
	"200": 0.98,
	"300": 0.99,
	"400": 1,
	"450": 1.02,
	"500": 1.03,
	"600": 1.06,
	"700": 1.09,
	"800": 1.13,
	"900": 1.16
};
var characterWidthOffsets = {
	fontSize: fontSize,
	fontWeight: fontWeight
};

export { characterWidthOffsets as default, fontSize, fontWeight };
